import React from "react";
import { PaymentTypeOptions } from "Types/state";
import cellDropdownRender from "./CellDropdown";
import WithOpen from "./WithOpen";

const CellDropdown = ({
    options,
    paymentType,
    selected,
    dataKey,
    onUpdate,
    title,
    vin,
}: {
    options: {
        cash?: [{ value: string; text: string }];
        loan?: [{ value: string; text: string }];
        lease?: [{ value: string; text: string }];
    };
    paymentType: PaymentTypeOptions;
    selected: string;
    dataKey: string;
    onUpdate: (vin: string, key: string, value: any) => void;
    title?: string;
    vin: string;
}) => {
    return (
        <WithOpen
            vin={vin}
            dataKey={dataKey}
            onUpdate={onUpdate}
            options={options[paymentType] || []}
            paymentType={paymentType}
            value={
                options[paymentType]?.find(
                    (paymentTypeOptions) => paymentTypeOptions?.value?.toString() === selected?.toString()
                )?.text ?? ""
            }
            render={cellDropdownRender}
            title={title}
        />
    );
};

export default CellDropdown;
